export default __webpack_public_path__ + "static/media/FE_Selected_Icon.605166f5.svg";